<template>
  <div id="shopping-tools-tiles" class="sokal-py-4 sokal-pt-0" :data-brand="this.$store.state.chosenBrand">
    <div class="sokal-modern-styles">
        <div class="sokal-container">
            <div class="sokal-vertical-space">
                <div class="sokal-space-y-2"></div>
            </div>
              <div class="sokal-my-1 sokal-mx-1">
                <p class="shopping-tools-super-title"> {{ sectionContent.superTitle }} </p>
                <h2 class="shopping-tools-title sokal-mt-0"> {{ sectionContent.title }} </h2>
              </div>
              <div class="row row-no-gutters">
                  <div class="col-xs-12">
                      <div
                          class="sokal-grid">
                          <!-- Card -->
                          <a
                            v-for="card in currentCards"
                            :key="card.title"
                            href="#"
                            class="sokal-card sokal-inline-flex sokal-w-auto has-border-radius lazyload sokal-relative"
                            :class="card.grid"
                            :style="{ backgroundImage: `url('${card.image}')` }"
                          >
                            <div class="sokal-bg-cover"></div>

                            <div class="sokal-inline-flex sokal-items-start sokal-justify-end sokal-flex-col text-left">
                              <div class="sokal-card-content sokal-color-light">
                                <p class="h2 sokal-m-0">{{ card.title }}</p>
                              </div>
                            </div>

                          </a>
                      </div>
                  </div>
              </div>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        cards: {
          ford: [
            {
              title: 'Schedule Service',
              image: 'https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/774/354/original/inventory.png?1763656691',
              grid: 'grid-1'
            },
            {
              title: 'Value Your Trade',
              image: 'https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/774/356/original/trade.png?1763656692',
              grid: 'grid-2'
            },
            {
              title: 'Get Pre-Approved',
              image: 'https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/774/355/original/service.png?1763656692',
              grid: 'grid-3'
            },
            {
              title: 'Search Inventory',
              image: 'https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/774/353/original/approved.png?1763656691',
              grid: 'grid-4'
            }
          ],

          cjdr: [
            {
              title: 'Search Inventory',
              image: 'https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/931/726/original/search_%281%29.png?1771618983',
              grid: 'grid-1'
            },
            {
              title: 'Value Your Trade',
              image: 'https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/931/727/original/value_%281%29.png?1771618983',
              grid: 'grid-2'
            },
            {
              title: 'Schedule Service',
              image: 'https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/931/729/original/sched_%281%29.png?1771618984',
              grid: 'grid-3'
            },
            {
              title: 'Get Pre-Approved',
              image: 'https://d2v1gjawtegg5z.cloudfront.net/uploads/files/001/931/728/original/approve_%281%29.png?1771618984',
              grid: 'grid-4'
            }
          ]
        }

      }
    },

    computed: {
      brand() {
        return (this.$store.state.chosenBrand || 'none')
          .toLowerCase()
          .trim();
      },

      currentCards() {
        return this.cards[this.brand] || [];
      },

      sectionContent() {
        const content = {
          ford: {
            superTitle: 'Explore',
            title: 'Hometown Shopping Tools'
          },

          cjdr: {
            superTitle: 'Hometown Chrysler Dodge Jeep Ram',
            title: 'Explore what Hometown has to offer'
          }
        }

        return content[this.brand] || {
          superTitle: 'Hometown Dealer',
          title: 'Explore what Hometown has to offer'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/sokal-utility-classes.scss';
  @import '@/assets/styles/sokal-modern-styles.scss';
  @import '@/assets/styles/modern-utility-classes.scss';
  @import '@/assets/styles/sokal_utility_classes_responsive.scss';
</style>

<style>

  #shopping-tools-tiles {
    background-color: var(--primary-dark);
    color: #ffffff;
  }

  #shopping-tools-tiles .shopping-tools-super-title {
    color: var(--secondary-color);
    font-size: 1.4rem;
  }
  #shopping-tools-tiles .shopping-tools-super-title .brand-insert {
    text-transform: capitalize;
  }

  #shopping-tools-tiles .shopping-tools-title {
    font-size: 3rem;
    color: var(--primary-light);
  }

  #shopping-tools-tiles .sokal-bg-cover {
    -webkit-backdrop-filter: brightness(0.8);
    backdrop-filter: brightness(0.8);
    -webkit-transition: all 0.2s linear;
    transition: all 0.2s linear;
    border-radius: 10px;
  }

  #shopping-tools-tiles a:hover .sokal-bg-cover,
  #shopping-tools-tiles a:focus .sokal-bg-cover {
    -webkit-backdrop-filter: brightness(0.5);
    backdrop-filter: brightness(0.5);
  }
  #shopping-tools-tiles .sokal-grid {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, auto);
    gap: 10px;
  }

  #shopping-tools-tiles .grid-1 {
    grid-column: 1 / span 2;
    grid-row: 1 / span 2;
  }

  #shopping-tools-tiles .grid-2 {
    grid-column: 3 / span 2;
    grid-row: 1;
  }

  #shopping-tools-tiles .grid-3 {
    grid-column: 3;
    grid-row: 2;
  }

  #shopping-tools-tiles .grid-4 {
    grid-column: 4;
    grid-row: 2;
  }

  #shopping-tools-tiles .sokal-grid .sokal-card {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    min-height: 20em;
  }

  #shopping-tools-tiles .sokal-grid .sokal-card:hover,
  #shopping-tools-tiles .sokal-grid .sokal-card:focus
  #shopping-tools-tiles .sokal-grid .sokal-card:active {
    text-decoration: none;
  }

  /* CJDR */
  #shopping-tools-tiles[data-brand="cjdr"] .shopping-tools-super-title {
    font-size: 1.4rem;
    font-family: "Barlow Condensed", sans-serif;
    font-weight: 700;
    font-style: normal;
    text-transform: uppercase;
  }
  #shopping-tools-tiles[data-brand="cjdr"] .shopping-tools-title .brand-insert{
    text-transform: uppercase;
  }

  @media (max-width: 1199px) {
    #shopping-tools-tiles .sokal-grid {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto auto;
    }

    #shopping-tools-tiles .grid-1 {
      grid-column: 1 / span 1;
      grid-row: 1;
    }

    #shopping-tools-tiles .grid-2 {
      grid-column: 2 / span 1;
      grid-row: 1;
    }

    #shopping-tools-tiles .grid-3 {
      grid-column: 1;
      grid-row: 2;
    }

    #shopping-tools-tiles .grid-4 {
      grid-column: 2;
      grid-row: 2;
    }
  }

  @media (max-width: 767px) {
    #shopping-tools-tiles .sokal-grid {
      grid-template-columns: 1fr;
    }

    #shopping-tools-tiles .sokal-grid .sokal-card {
      grid-column: 1;
      grid-row: auto;
    }
  }
</style>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>